<div class="mt-2 row">
    <div *ngFor="let count of qrCodeCountList" class="col-2">
        <img src='{{count}}' alt="QR Code">
    </div>
</div>
